<img [ngClass]="[imageClass]" src="{{imageSrc}}" alt="{{imageAltName}}">